module.exports = __webpack_public_path__ + "img/desktop.ef86ddaa.jpg";